<template>
  <fragment>
    <common-header
      subname="시스템 관리"
      name="목록 필터 관리"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      v-bind:mainmenuOpened="true"
    ></common-header>

    <section ref="container" class="container">
      <nav class="side-nav">
        <ul class="side-nav-menu">
          <li>
            <a>회원 관리</a>
            <ul>
              <li>
                <a :class="{on:listName=='수강생 목록'}" @click="listName='수강생 목록'">- 수강생 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='강사 목록'}" @click="listName='강사 목록'">- 강사 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='관리자 목록'}" @click="listName='관리자 목록'">- 관리자 목록</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="#none">강좌관리</a>
            <ul>
              <li>
                <a :class="{on:listName=='강좌 목록'}" @click="listName='강좌 목록'">- 강좌 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='수강 신청 목록'}" @click="listName='수강 신청 목록'">- 수강 신청 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='수강현황 목록'}" @click="listName='수강현황 목록'">- 수강현황 목록</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="#none">추가관리</a>
            <ul>
              <li>
                <a :class="{on:listName=='전자우편 양식 목록'}" @click="listName='전자우편 양식 목록'">- 전자우편 양식 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='보낸 우편함 목록'}" @click="listName='보낸 우편함 목록'">- 보낸 우편함 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='문자 양식 목록'}" @click="listName='문자 양식 목록'">- 문자 양식 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='보낸 문자함 목록'}" @click="listName='보낸 문자함 목록'">- 보낸 문자함 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='소속기관 목록'}" @click="listName='소속기관 목록'">- 소속기관 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='시험문항 목록'}" @click="listName='시험문항 목록'">- 시험문항 목록</a>
              </li>
              <li>
                <a :class="{on:listName=='설문문항 목록'}" @click="listName='설문문항 목록'">- 설문문항 목록</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div class="container-fiuld">
        <p class="f-18 text-darkgray m-t-15 m-b-10">{{listName}}</p>
        <table class="table2 m-t-10 text-center">
          <tbody>
            <tr class="bg-none">
              <td class="p-10">
                <div class="input-group full-width">
                  <span class="input-group-addon v-mid text-white w200 p-r-5">
                    <input
                      class="inline form-control-sm w200 m-b-0 round v-mid"
                      type="text"
                      placeholder="새 항목 명칭"
                      v-model="newFilterGroup.filterName"
                    />
                  </span>
                  <span class="input-group-addon v-mid p-r-5">
                    <input
                      class="form-control-sm full-width m-b-0 round"
                      type="text"
                      placeholder="테이블명 또는 쿼리문 입력"
                      v-model="newFilterGroup.query"
                    />
                  </span>
                  <span class="input-group-addon w100 v-mid">
                    <button
                      class="btn-sm bg-deepblue full-width text-white round v-mid"
                      type="button"
                      @click="addFilterGroup"
                    >필터그룹 추가</button>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <vue-draggable
          v-model="filterGroups"
          tag="table"
          class="table2 m-t-10 text-center"
          handle=".handleGroup"
          group="filterGroups"
          v-bind="dragOptions"
          @end="moveGroup($event)"
        >
          <tbody v-for="(group, groupIndex) in filterGroups_" :key="hash(filterGroups[groupIndex])">
            <tr class="margin">
              <td colspan="3"></td>
            </tr>
            <tr class="on">
              <th class="w200 p-10" v-if="!group.modifying_">
                <div class="w200">{{group.filterName}}</div>
              </th>
              <th class="w200 p-10" v-if="group.modifying_">
                <div class="w200">
                  <input
                    class="inline form-control-sm w200 m-b-0 round v-mid"
                    type="text"
                    v-model="filterGroups_[groupIndex].filterName"
                  />
                </div>
              </th>

              <th class="full-width p-10" v-if="!group.modifying_">{{group.query}}</th>
              <th class="full-width p-10" v-if="group.modifying_">
                <input
                  class="form-control-sm full-width m-b-0 round"
                  type="text"
                  v-model="filterGroups_[groupIndex].query"
                />
              </th>

              <th class="p-10 w100" v-if="!group.modifying_">
                <a class="move m-r-5 handleGroup">이동</a>
                <a class="modify m-r-5" @click="toggleModifying(groupIndex)">수정</a>
                <a class="del" @click="deleteFilter(groupIndex)">삭제</a>
              </th>
              <th class="p-10 w100" v-if="group.modifying_">
                <button
                  class="btn-sm bg-deepblue full-width text-white round v-mid"
                  type="button"
                  @click="modifyFilter(groupIndex)"
                >수정완료</button>
              </th>
            </tr>
            <tr class="margin">
              <td colspan="3"></td>
            </tr>
            <tr>
              <td class="w200 round" colspan="3">
                <div class="input-group full-width m-b-10">
                  <span class="input-group-addon v-mid text-white w200 p-r-5">
                    <input
                      class="inline form-control-sm w200 m-b-0 round v-mid"
                      type="text"
                      placeholder="새 항목 명칭"
                      v-model="filterGroups_[groupIndex].newFilterItem_.filterName"
                    />
                  </span>
                  <span class="input-group-addon v-mid text-white w300 p-r-5">
                    <select
                      class="inline form-control-sm w300 m-b-0 round v-mid"
                      v-model="filterGroups_[groupIndex].newFilterItem_.type"
                    >
                      <option value>사용자 입력 없음</option>
                      <option value="텍스트">텍스트</option>
                      <option value="숫자">숫자</option>
                      <option value="숫자범위">숫자범위 (최소값~최대값)</option>
                      <option value="시각">특정시각</option>
                      <option value="날짜">특정날짜</option>
                      <option value="날짜범위">날짜범위 (시작일~종료일)</option>
                      <option value="날짜시각">특정날짜 특정시각</option>
                      <option value="날짜시각범위">날짜시각범위 (시작일시~종료일시)</option>
                    </select>
                  </span>
                  <span class="input-group-addon v-mid p-r-5">
                    <input
                      class="form-control-sm full-width m-b-0 round"
                      type="text"
                      placeholder="SQL 조건절 입력"
                      v-model="filterGroups_[groupIndex].newFilterItem_.query"
                    />
                  </span>
                  <span class="input-group-addon w100 v-mid">
                    <button
                      class="btn-sm bg-deepblue full-width text-white round v-mid"
                      type="button"
                      @click="addFilterItem(groupIndex)"
                    >항목추가</button>
                  </span>
                </div>
                <vue-draggable
                  v-model="group.child"
                  tag="div"
                  handle=".handleItem"
                  :group="hash(group)"
                  v-bind="dragOptions"
                  @end="moveItem(groupIndex,$event)"
                >
                  <div
                    v-for="(item, itemIndex) in group.child"
                    :key="hash(filterGroups[groupIndex].child[itemIndex])"
                    class="input-group full-width m-b-10"
                  >
                    <span
                      class="input-group-addon v-mid w200 p-r-5"
                      v-if="!item.modifying_"
                    >{{ item.filterName }}</span>
                    <span
                      class="input-group-addon v-mid text-white w200 p-r-5"
                      v-if="item.modifying_"
                    >
                      <input
                        class="inline form-control-sm w200 m-b-0 round v-mid"
                        type="text"
                        placeholder="항목 명칭"
                        v-model="filterGroups_[groupIndex].child[itemIndex].filterName"
                      />
                    </span>

                    <span
                      class="input-group-addon v-mid w300 p-r-5"
                      v-if="!item.modifying_"
                    >{{ item.type?item.type:"사용자 입력 없음" }}</span>
                    <span
                      class="input-group-addon v-mid text-white w300 p-r-5"
                      v-if="item.modifying_"
                    >
                      <select
                        class="inline form-control-sm w300 m-b-0 round v-mid"
                        v-model="filterGroups_[groupIndex].child[itemIndex].type"
                      >
                        <option value>사용자 입력 없음</option>
                        <option value="텍스트">텍스트</option>
                        <option value="숫자">숫자</option>
                        <option value="숫자범위">숫자범위 (최소값~최대값)</option>
                        <option value="시각">특정시각</option>
                        <option value="날짜">특정날짜</option>
                        <option value="날짜범위">날짜범위 (시작일~종료일)</option>
                        <option value="날짜시각">특정날짜 특정시각</option>
                        <option value="날짜시각범위">날짜시각범위 (시작일시~종료일시)</option>
                      </select>
                    </span>

                    <span
                      class="input-group-addon v-mid p-r-5"
                      v-if="!item.modifying_"
                    >{{ item.query }}</span>
                    <span class="input-group-addon v-mid p-r-5" v-if="item.modifying_">
                      <input
                        class="form-control-sm full-width m-b-0 round"
                        type="text"
                        placeholder="SQL 조건절 입력"
                        v-model="filterGroups_[groupIndex].child[itemIndex].query"
                      />
                    </span>

                    <span class="input-group-addon w100 v-mid" v-if="!item.modifying_">
                      <a class="move m-r-5 handleItem">이동</a>
                      <a class="modify m-r-5" @click="toggleModifying(groupIndex, itemIndex)">수정</a>
                      <a class="del" @click="deleteFilter(groupIndex, itemIndex)">삭제</a>
                    </span>
                    <span class="input-group-addon w100 v-mid" v-if="item.modifying_">
                      <button
                        class="btn-sm bg-deepblue full-width text-white round v-mid"
                        type="button"
                        @click="modifyFilter(groupIndex, itemIndex)"
                      >수정완료</button>
                    </span>
                  </div>
                </vue-draggable>
              </td>
            </tr>
          </tbody>
        </vue-draggable>
      </div>
    </section>

    <modal-confirm
      :config="modals.confirm"
      :key="hash(modals.confirm)"
      @no="modals.confirm.show=false"
    ></modal-confirm>
    <modal-alert :config="modals.alert" :key="hash(modals.alert)" @close="modals.alert.show=false"></modal-alert>

    <common-footer></common-footer>
  </fragment>
</template>

<script>
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import axios from "axios";
import server from "../statics/server.js";
import VueDraggable from "vuedraggable";

import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";

export default {
  // 컴포넌트 명칭
  name: "ViewFilterList",
  mixins: [fnAdjustHeight],

  // 이 컴포넌트에서 사용할 자식컴포넌트 목록
  components: {
    VueDraggable,
    CommonHeader,
    CommonFooter,
    ModalAlert,
    ModalConfirm
  },

  // 이 컴포넌트가 DOM에 마운트될 때,
  mounted: function() {
    // 필터그룹 목록 조회
    this.getFilters(this.listName);
  },

  // 이 컴포넌트에서 내부적으로 사용할 데이터
  data: function() {
    return {
      menus: [
        // 서브메뉴
        { name: "로그조회", link: "" },
        { name: "공통코드 관리", link: "" },
        { name: "목록 필터 관리", link: "/filters", selected: true }
      ],
      buttons: [], // 헤더버튼
      modals: {
        alert: ModalAlert.default(),
        confirm: ModalConfirm.default()
      }, // 모달설정객체

      listName: "수강생 목록", // 현재 선택된 목록명

      newFilterGroup: { filterName: "", query: "" }, // 새 필터그룹을 만들 때 사용할 데이터
      filterGroups: [], // 필터그룹 목록 (렌더링에 사용되는 데이터)
      filterGroups_: [] // 필터그룹 목록 (내부적으로 관리하는 데이터)
    };
  },

  // 미리 계산된 option 값 들
  computed: {
    dragOptions() {
      return {
        ghostClass: "ghost"
      };
    }
  },

  // data변경 감지
  watch: {
    listName: function(newValue) {
      this.getFilters(newValue);
    }
  },

  // 이 컴포넌트에서 구현되어야 할 기능
  methods: {
    /*
     ** 필터그룹목록과 각 필터그룹별 하위항목들의 목록을 조회한다.
     */
    getFilters: function(listName) {
      axios
        .post(server.addr() + server.api.FILTERS_ALL, {
          listName
        })
        .then(response => {
          if (response.status == 200) {
            if (response.data) {
              this.filterGroups = [...response.data.list];
              this.filterGroups_ = JSON.parse(
                JSON.stringify(response.data.list)
              );
              this.filterGroups_.forEach(o => {
                o.newFilterItem_ = { filterName: "", type: "", query: "" };
              });
            } else {
              this.filterGroups = [];
              this.filterGroups_ = [];
            }
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  POST " + server.api.FILTERS,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
          /* eslint-enable */
        });
    },
    /*
     ** 필터그룹이나 항목을 삭제한다.
     */
    deleteFilter: function(groupIndex, childIndex) {
      // 아이템이 주어지지 않은 경우, 필터그룹을 삭제하고
      if (childIndex === undefined) {
        this.modals.confirm.msg =
          "필터그룹 " +
          this.filterGroups_[groupIndex].filterName +
          " 을 정말 삭제하시겠습니까?";
        this.modals.confirm.btnYes.fn = () => {
          axios
            .delete(
              server.addr() +
                server.api.FILTERS +
                "/" +
                this.filterGroups_[groupIndex].filterId
            )
            .then(response => {
              if (response.status == 200) {
                // 화면에 새 필터항목을 그린다.
                this.filterGroups.splice(groupIndex, 1);
                this.filterGroups_.splice(groupIndex, 1);
                this.modals.confirm.show = false;
              } else {
                this.modals.alert.msg =
                  "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
                  response.status +
                  ")";
                this.modals.alert.show = true;
              }
            })
            .catch(error => {
              this.modals.confirm.show = false;
              this.modals.alert.msg = "서버와 통신할 수 없습니다.";
              this.modals.alert.show = true;
              /* eslint-disable */
              if (error) {
                console.log(
                  "-----------------------------------------------------------------------------------"
                );
                console.log(
                  "ERROR  on  DELETE " +
                    server.api.FILTERS +
                    "/" +
                    this.filterGroups[groupIndex].filterId,
                  " at ",
                  new Date()
                );
                console.log(error);
                if (
                  error.response &&
                  (error.response.data || error.response.config)
                )
                  console.log(
                    "-----------------------------------------------------------------------------------"
                  );
                if (error.response && error.response.data)
                  console.log("response body: ", error.response.data);
                if (error.response && error.response.config)
                  console.log("request config: ", error.response.config);
                console.log(
                  "-----------------------------------------------------------------------------------"
                );
              } else {
                console.log("error Object not exists.");
              }
              /* eslint-enable */
            });
        };
        this.modals.confirm.show = true;
      }
      // 아이템이 주어진 경우, 필터그룹내의 항목을 삭제한다.
      else {
        this.modals.confirm.msg =
          "필터그룹 " +
          this.filterGroups_[groupIndex].filterName +
          " 내의 항목 " +
          this.filterGroups_[groupIndex].child[childIndex].filterName +
          " 을 정말 삭제하시겠습니까?";
        this.modals.confirm.btnYes.fn = () => {
          axios
            .delete(
              server.addr() +
                server.api.FILTERS +
                "/" +
                this.filterGroups_[groupIndex].child[childIndex].filterId
            )
            .then(response => {
              if (response.status == 200) {
                // 화면에 새 필터항목을 그린다.
                this.filterGroups[groupIndex].child.splice(childIndex, 1);
                this.filterGroups_[groupIndex].child.splice(childIndex, 1);
                this.modals.confirm.show = false;
              } else {
                this.modals.alert.msg =
                  "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
                  response.status +
                  ")";
                this.modals.alert.show = true;
              }
            })
            .catch(error => {
              this.modals.alert.msg = "서버와 통신할 수 없습니다.";
              this.modals.alert.show = true;
              /* eslint-disable */
              if (error) {
                console.log(
                  "-----------------------------------------------------------------------------------"
                );
                console.log(
                  "ERROR  on  DELETE " +
                    server.api.FILTERS +
                    "/" +
                    this.filterGroups[groupIndex].child[childIndex].filterId,
                  " at ",
                  new Date()
                );
                console.log(error);
                if (
                  error.response &&
                  (error.response.data || error.response.config)
                )
                  console.log(
                    "-----------------------------------------------------------------------------------"
                  );
                if (error.response && error.response.data)
                  console.log("response body: ", error.response.data);
                if (error.response && error.response.config)
                  console.log("request config: ", error.response.config);
                console.log(
                  "-----------------------------------------------------------------------------------"
                );
              } else {
                console.log("error Object not exists.");
              }
              /* eslint-enable */
            });
        };
        this.modals.confirm.show = true;
      }
    },
    /*
     ** 필터그룹이나 필터항목의 수정모드를 토글한다.
     */
    toggleModifying: function(groupIndex, childIndex) {
      if (childIndex === undefined) {
        if (this.filterGroups[groupIndex].modifying_) {
          this.$set(this.filterGroups[groupIndex], "modifying_", false);
          this.filterGroups_[groupIndex].modifying_ = false;
        } else {
          this.$set(this.filterGroups[groupIndex], "modifying_", true);
          this.filterGroups_[groupIndex].modifying_ = true;
        }
      } else {
        if (this.filterGroups[groupIndex].child[childIndex].modifying_) {
          this.$set(
            this.filterGroups[groupIndex].child[childIndex],
            "modifying_",
            false
          );
          this.filterGroups_[groupIndex].child[childIndex].modifying_ = false;
        } else {
          this.$set(
            this.filterGroups[groupIndex].child[childIndex],
            "modifying_",
            true
          );
          this.filterGroups[groupIndex].child[childIndex].modifying_ = true;
        }
      }
    },
    /*
     ** 필터그룹이나 필터항목을 수정한다.
     */
    modifyFilter: function(groupIndex, childIndex) {
      axios
        .patch(
          server.addr() +
            server.api.FILTERS +
            "/" +
            (childIndex === undefined
              ? this.filterGroups_[groupIndex].filterId
              : this.filterGroups_[groupIndex].child[childIndex].filterId),
          {
            filterName:
              childIndex === undefined
                ? this.filterGroups_[groupIndex].filterName
                : this.filterGroups_[groupIndex].child[childIndex].filterName,
            type:
              childIndex === undefined
                ? this.filterGroups_[groupIndex].type
                : this.filterGroups_[groupIndex].child[childIndex].type,
            query:
              childIndex === undefined
                ? this.filterGroups_[groupIndex].query
                : this.filterGroups_[groupIndex].child[childIndex].query
          }
        )
        .then(response => {
          if (response.status == 200) {
            // 화면에 수정된 필터내용을 그린다.
            if (childIndex === undefined) {
              this.filterGroups[groupIndex].filterName = this.filterGroups_[
                groupIndex
              ].filterName;
              this.filterGroups[groupIndex].query = this.filterGroups_[
                groupIndex
              ].query;
              this.filterGroups[groupIndex].modifying_ = false;
              this.filterGroups_[groupIndex].modifying_ = false;
            } else {
              this.filterGroups[groupIndex].child[
                childIndex
              ].filterName = this.filterGroups_[groupIndex].child[
                childIndex
              ].filterName;
              this.filterGroups[groupIndex].child[
                childIndex
              ].type = this.filterGroups_[groupIndex].child[childIndex].type;
              this.filterGroups[groupIndex].child[
                childIndex
              ].query = this.filterGroups_[groupIndex].child[childIndex].query;
              this.filterGroups[groupIndex].child[
                childIndex
              ].modifying_ = false;
              this.filterGroups_[groupIndex].child[
                childIndex
              ].modifying_ = false;
            }
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  PATCH " + server.api.FILTERS + "/" + obj.filterId,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
        });
    },
    /*
     ** 새 필터항목을 추가한다.
     */
    addFilterItem: function(groupIndex) {
      if (
        this.filterGroups_[groupIndex].newFilterItem_.filterName.trim()
          .length == 0 ||
        this.filterGroups_[groupIndex].newFilterItem_.query.trim().length == 0
      ) {
        this.modals.alert.msg = "새로 만들 필터항목의 명칭을 입력하세요.";
        this.modals.alert.show = true;
        return;
      }

      // eslint-disable-next-line
      console.log("필터항목 추가", {
        listName: this.listName,
        parentsId: this.filterGroups_[groupIndex].filterId,
        filterName: this.filterGroups_[groupIndex].newFilterItem_.filterName,
        query: this.filterGroups_[groupIndex].newFilterItem_.query,
        type: this.filterGroups_[groupIndex].newFilterItem_.type
      });

      // 새 필터항목 추가 api 호출한다.
      axios
        .put(server.addr() + server.api.FILTERS, [
          {
            listName: this.listName,
            parentsId: this.filterGroups_[groupIndex].filterId,
            filterName: this.filterGroups_[groupIndex].newFilterItem_
              .filterName,
            query: this.filterGroups_[groupIndex].newFilterItem_.query,
            type: this.filterGroups_[groupIndex].newFilterItem_.type
          }
        ])
        .then(response => {
          if (response.status == 200) {
            // 화면에 새 필터항목을 그리고
            this.filterGroups_[groupIndex].child.unshift({
              filterName: this.filterGroups_[groupIndex].newFilterItem_
                .filterName,
              type: this.filterGroups_[groupIndex].newFilterItem_.type,
              query: this.filterGroups_[groupIndex].newFilterItem_.query,
              modifying_: false
            });
            // 새 필터항목을 만들 때 사용할 데이터를 비운다.
            this.filterGroups_[groupIndex].newFilterItem_.filterName = "";
            this.filterGroups_[groupIndex].newFilterItem_.query = "";
            this.filterGroups_[groupIndex].newFilterItem_.type = "";
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  PUT " + server.api.FILTERS,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
          /* eslint-enable */
        });
    },
    /*
     ** 새 필터그룹을 추가한다.
     */
    addFilterGroup: function() {
      if (this.newFilterGroup.filterName.trim().length == 0) {
        this.modals.alert.msg = "새로 만들 필터그룹의 명칭을 입력하세요.";
        this.modals.alert.show = true;
        return;
      }
      // 새 필터그룹 추가 api 호출한다.
      axios
        .put(server.addr() + server.api.FILTERS, [
          {
            listName: this.listName,
            parentsId: 0,
            filterName: this.newFilterGroup.filterName,
            query: this.newFilterGroup.query,
            type: null
          }
        ])
        .then(response => {
          if (response.status == 200) {
            // 화면에 새 필터그룹을 그리고
            this.filterGroups.unshift({
              filterId: response.data.list[0].filterId,
              filterName: this.newFilterGroup.filterName,
              query: this.newFilterGroup.query,
              child: []
            });
            this.filterGroups_.unshift({
              filterId: response.data.list[0].filterId,
              filterName: this.newFilterGroup.filterName,
              query: this.newFilterGroup.query,
              child: [],
              newFilterItem_: { filterName: "", type: "", query: "" }
            });
            // 새 필터그룹을 만들 때 사용할 데이터를 비운다.
            this.newFilterGroup.filterName = "";
            this.newFilterGroup.query = "";
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  PUT " + server.api.FILTERS,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
          /* eslint-enable */
        });
    },
    /*
     ** 필터그룹의 순서를 이동한다.
     */
    moveGroup: function(e) {
      axios
        .patch(
          server.addr() +
            server.api.FILTERS +
            "/" +
            this.filterGroups[e.newIndex].filterId,
          {
            dst:
              e.newIndex == 0 ? 0 : this.filterGroups[e.newIndex - 1].filterId
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.filterGroups_ = JSON.parse(JSON.stringify(this.filterGroups));
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
            this.getFilters(this.listName);
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  PATCH " +
                server.api.FILTERS +
                "/" +
                this.filterGroups[e.newIndex].filterId,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
          /* eslint-enable */
        });
    },
    /*
     ** 필터항목의 순서를 이동한다.
     */
    moveItem: function(groupIndex, e) {
      // eslint-disable-next-line
      console.log("여기까진 오는거 맞음?");

      axios
        .patch(
          server.addr() +
            server.api.FILTERS +
            "/" +
            this.filterGroups[groupIndex].child[e.newIndex].filterId,
          {
            dst:
              e.newIndex == 0
                ? 0
                : this.filterGroups[groupIndex].child[e.newIndex - 1].filterId
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.filterGroups_[groupIndex] = JSON.parse(
              JSON.stringify(this.filterGroups[groupIndex])
            );
          } else {
            this.modals.alert.msg =
              "이 동작을 수행 할 권한이 없습니다. (오류코드 " +
              response.status +
              ")";
            this.modals.alert.show = true;
            this.getFilters(this.listName);
          }
        })
        .catch(error => {
          this.modals.alert.msg = "서버와 통신할 수 없습니다.";
          this.modals.alert.show = true;
          /* eslint-disable */
          if (error) {
            console.log(
              "-----------------------------------------------------------------------------------"
            );
            console.log(
              "ERROR  on  PATCH " +
                server.api.FILTERS +
                "/" +
                this.filterGroups[groupIndex].child[e.newIndex].filterId,
              " at ",
              new Date()
            );
            console.log(error);
            if (
              error.response &&
              (error.response.data || error.response.config)
            )
              console.log(
                "-----------------------------------------------------------------------------------"
              );
            if (error.response && error.response.data)
              console.log("response body: ", error.response.data);
            if (error.response && error.response.config)
              console.log("request config: ", error.response.config);
            console.log(
              "-----------------------------------------------------------------------------------"
            );
          } else {
            console.log("error Object not exists.");
          }
          /* eslint-enable */
        });
    }
  }
};
</script>